import { FC } from 'react';
import { Button } from 'antd';
import FurronLogo from '../../assets/img/furon.svg';
import SGLogo from '../../assets/img/SGlogo.svg';
import { isAuthenticated } from '../../services/authenticationService';
import { useNavigate } from 'react-router-dom';
import './login.css';
import React from 'react';
import { getVerifier, pkceChallengeFromVerifier } from "../../services/pkceService";

const LoginPage: FC = () => {

  let navigate = useNavigate();
  const verifier = getVerifier();
  React.useEffect(() => {
    if (isAuthenticated()) {
      navigate('/users');
    }
  })

  const openSSO: any = async (e: Event) => {
    e.preventDefault();
    const challenge = await pkceChallengeFromVerifier(verifier);
    const URL = process.env.REACT_APP_WEB_SSO + '?response_type=code&client_id=' + process.env.REACT_APP_CLIENT_ID +
      '&scope=profile openid stGoSGI email &redirect_uri=' + process.env.REACT_APP_REDIRECT_URI + '&code_challenge_method=S256&code_challenge=' + challenge + '&state=rV7PjL2bW9ZnfxqR0EcsMvUghYkQaXTe&nonce=rV7PjL2bW9ZnfxqR0EcsMvUghYkQaXTe';
    console.log("url", URL);
    window.location.href = URL;
  }

  return (
    <div className='container'>
      <div className="content-container">
        <img src={FurronLogo} alt="" />
        <p> Welcome to Furon Fitting Configurator Backoffice</p>
        <div style={{ paddingTop: '5%' }}>
          <Button type="primary" className='loginbutton' onClick={openSSO}>
            Login with SSO</Button>
        </div>
      </div>
      <div className='sglogo'>
        <img src={SGLogo} alt="" />
        <p style={{ fontSize: '12px', padding: '0' }}>V1.0</p>
      </div>
    </div>
  );
};

export default LoginPage;
